import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { paperGoodsReceiptBusiness } from "api/bussiness/paper-material/paper-goods-receipt";
import { PaperMaterialInventoriesPermission } from "commons/enum/permission";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IPaperGoodsReceiptProperties } from "mobx-stores/_models/paper-inventory/paper-goods-receipt/paper-goods-receipt";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import {
  EditIconButton,
  RemoveIconButton,
} from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const PaperGoodsReceiptTable = observer(() => {
  const {
    deleteConfirmationStore,
    paperInventoryManagement: {
      paperGoodsReceiptStore: {
        paperGoodsReceipts,
        getPaperGoodsReceipt,
        pagination,
        setProp,
        searchConditionAsNaturalLanguage,
      },
    },
  } = useStores();

  useEffect(() => {
    getPaperGoodsReceipt();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getPaperGoodsReceipt();
    },
    [getPaperGoodsReceipt, pagination]
  );

  const onEditBtnClickHandler = useCallback(
    (item: IPaperGoodsReceiptProperties) => {
      setProp("openEdit", true);
      setProp("paperGoodsReceiptDetail", cloneDeep(item));
    },
    [setProp]
  );

  const onDelete = useCallback(
    async (item: IPaperGoodsReceiptProperties) => {
      if (item && item.id) {
        await paperGoodsReceiptBusiness.delete(item?.id);
        getPaperGoodsReceipt();
      }
    },
    [getPaperGoodsReceipt]
  );

  const onDeleteBtnClickHandler = useCallback(
    (item: IPaperGoodsReceiptProperties) => {
      setProp("paperGoodsReceiptDetail", cloneDeep(item));
      deleteConfirmationStore.setProp("open", true);
      deleteConfirmationStore.setDeletionCallback(() => {
        onDelete(item);
      });
    },
    [deleteConfirmationStore, onDelete, setProp]
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
      searchConditionAsNaturalLanguage={searchConditionAsNaturalLanguage}
    >
      <TableHead>
        <TableRow>
          <TableCell>Mã số</TableCell>
          <TableCell>Số cuồn</TableCell>
          <TableCell>Loại giấy</TableCell>
          <TableCell>GSM</TableCell>
          <TableCell>Khổ</TableCell>
          <TableCell>Dài</TableCell>
          <TableCell>Ngày nhập</TableCell>
          <TableCell>Số lượng</TableCell>
          <TableCell>Vị trí kho</TableCell>
          <TableCell>Hiệu</TableCell>
          <TableCell>Số seri</TableCell>
          <TableCell>Xuất xứ</TableCell>
          <TableCell>Nhà CC</TableCell>
          <TableCell>Chứng từ</TableCell>
          <TableCell>Ghi chú</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {paperGoodsReceipts.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell>{x.items[0]?.material?.code || ""}</TableCell>
            <TableCell>{x.items[0]?.rollNumber || ""}</TableCell>
            <TableCell>{x.items[0]?.material?.type || ""}</TableCell>{" "}
            <TableCell>{x.items[0]?.material?.gsm || ""}</TableCell>
            <TableCell>
              {x.items[0]?.material?.specificationSize || ""}
            </TableCell>
            <TableCell>
              {x.items[0]?.material?.specificationLength || ""}
            </TableCell>
            <TableCell>{dateTimeDisplay(x.receiptDate) || ""}</TableCell>
            <TableCell>{x.items[0]?.amount || ""}</TableCell>
            <TableCell>{x.items[0]?.wareHouse || ""}</TableCell>
            <TableCell>{x.items[0]?.brand || ""}</TableCell>
            <TableCell>{x.items[0]?.serialNumber || ""}</TableCell>
            <TableCell>{x.items[0]?.origin || ""}</TableCell>
            <TableCell>{x.items[0]?.supplier || ""}</TableCell>
            <TableCell>{x.items[0]?.document || ""}</TableCell>
            <TableCell>{x.items[0]?.note || ""}</TableCell>
            <TableCell width={"20px"}>
              <Stack direction={"row"} spacing={0.5}>
                <EditIconButton
                  accessPermission={[
                    PaperMaterialInventoriesPermission.ReceiptUpdate,
                  ]}
                  onClick={() => onEditBtnClickHandler(x)}
                ></EditIconButton>

                <RemoveIconButton
                  accessPermission={[
                    PaperMaterialInventoriesPermission.ReceiptDelete,
                  ]}
                  onClick={() => onDeleteBtnClickHandler(x)}
                ></RemoveIconButton>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
